import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const CRMOnly = ({ component: Component, ...props }) => {
  const { isClient, isReferral, isContractor, isDriver, isVendor, isCustomer,isVendorStaff } = useAuth();

  if (isClient) return <Navigate to="/app/client" />;
  if (isContractor) return <Navigate to="/app/contractor/dashboard" />;
  if (isVendor) return <Navigate to="/app/vendor" />;
  if (isDriver) return <Navigate to="/app/driver" />;
  if (isCustomer) return <Navigate to="/app/customer" />;
  if (isVendorStaff) return <Navigate to="/app/staff/dashboard" />;


  if (isReferral) return <Navigate to="/app/referral" />;

  return <Component {...props} />;
};

export default CRMOnly;
